type Array = { [key: string]: any }[];

export const areArraysEqual = (array1: Array, array2: Array) => {
    if (array1.length !== array2.length) {
        return false;
    }
    for (let i = 0; i < array1.length; i++) {
        const obj1 = array1[i];
        const obj2 = array2[i];
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (let j = 0; j < keys1.length; j++) {
            const key = keys1[j];
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
    }
    return true;
}
